import React from "react";
import ClientRealLayout from "./Layout";
import ClientShiftsPageShell from "./ClientShiftsPageShell";
import TimesheetsPanel from "../components/timesheets/TimesheetsPanel";
import usePageMeta from "../hooks/usePageMeta";

const ClientShiftsTimesheets = () => {
  usePageMeta("Shifts — Timesheets");

  return (
    <ClientRealLayout>
      <ClientShiftsPageShell>
        <div className="mt-3 flex-1 min-h-0 overflow-y-auto">
          <div className="rounded-xl border-2 border-gray-200 bg-gray-50 p-4 min-h-0">
            <TimesheetsPanel variant="clientContact" active className="flex-none" />
          </div>
        </div>
      </ClientShiftsPageShell>
    </ClientRealLayout>
  );
};

export default ClientShiftsTimesheets;
